(function () {
  "use strict";

  var STORAGE_KEY = "bm_video_age_confirmed_v1";
  var STORAGE_DAYS = 30;

  function now() {
    return new Date().getTime();
  }

  function getStoredConfirmation() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);

      if (!raw) {
        return false;
      }

      var parsed = JSON.parse(raw);

      if (!parsed || !parsed.confirmedAt) {
        return false;
      }

      var maxAge = STORAGE_DAYS * 24 * 60 * 60 * 1000;
      var stillValid = now() - parsed.confirmedAt < maxAge;

      if (!stillValid) {
        window.localStorage.removeItem(STORAGE_KEY);
        return false;
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  function setStoredConfirmation() {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          confirmed: true,
          confirmedAt: now()
        })
      );
    } catch (error) {
      // localStorage can fail in private browsing. The video can still load for this session.
    }
  }

  function createVideoElement(wrapper, shouldAutoplay) {
    if (!wrapper) {
      return null;
    }

    if (wrapper.getAttribute("data-bm-video-loaded") === "true") {
      return wrapper.querySelector("video");
    }

    var src = wrapper.getAttribute("data-video-src");
    var type = wrapper.getAttribute("data-video-type") || "video/mp4";
    var poster = wrapper.getAttribute("data-video-poster") || "";
    var title = wrapper.getAttribute("data-video-title") || "Age-restricted video";

    if (!src) {
      wrapper.innerHTML = "<p>Video source missing.</p>";
      return null;
    }

    var video = document.createElement("video");
    video.setAttribute("controls", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("preload", "metadata");
    video.setAttribute("aria-label", title);

    if (shouldAutoplay) {
      video.setAttribute("autoplay", "");
    }

    if (poster) {
      video.setAttribute("poster", poster);
    }

    var source = document.createElement("source");
    source.setAttribute("src", src);
    source.setAttribute("type", type);

    video.appendChild(source);

    var fallback = document.createElement("p");
    var fallbackLink = document.createElement("a");
    fallbackLink.href = src;
    fallbackLink.textContent = "Open video";
    fallback.appendChild(document.createTextNode("Your browser does not support embedded video. "));
    fallback.appendChild(fallbackLink);

    video.appendChild(fallback);

    wrapper.innerHTML = "";
    wrapper.appendChild(video);
    wrapper.setAttribute("data-bm-video-loaded", "true");

    if (shouldAutoplay) {
      try {
        var playPromise = video.play();

        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {
            // Browser blocked autoplay. Leave controls visible so user can press play.
          });
        }
      } catch (error) {
        // Browser blocked autoplay. Leave controls visible.
      }
    }

    return video;
  }

  function loadAllAgeGatedVideos(clickedWrapper) {
    var wrappers = document.querySelectorAll(".bm-age-gated-video");

    wrappers.forEach(function (wrapper) {
      var shouldAutoplay = clickedWrapper && wrapper === clickedWrapper;
      createVideoElement(wrapper, shouldAutoplay);
    });
  }

  function declineVideo(wrapper) {
    if (!wrapper) {
      return;
    }

    wrapper.innerHTML = '<p class="bm-age-gate-declined">This video is only available to adults aged 18 or over.</p>';
  }

  function initAgeGatedVideos() {
    if (getStoredConfirmation()) {
      loadAllAgeGatedVideos(null);
    }
  }

  document.addEventListener("click", function (event) {
    var confirmButton = event.target.closest(".bm-age-gate-confirm");
    var declineButton = event.target.closest(".bm-age-gate-decline");

    if (confirmButton) {
      event.preventDefault();

      var clickedWrapper = confirmButton.closest(".bm-age-gated-video");

      setStoredConfirmation();
      loadAllAgeGatedVideos(clickedWrapper);

      return;
    }

    if (declineButton) {
      event.preventDefault();

      var wrapper = declineButton.closest(".bm-age-gated-video");
      declineVideo(wrapper);
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAgeGatedVideos);
  } else {
    initAgeGatedVideos();
  }
})();